import {RootState} from '../slices'

export const getRole = (state: RootState) => state.user.user.role?.role_slug
export const getClubInfo = (state: RootState) => state.user.user?.club_data
